import React from 'react'

import './App.css'
import FaceDetection from './FaceDetection'

function App() {


  return (
    <>
      <div className="app-header">
        <h1>[ DARKFORCE CORP ]</h1>
        <p>BIOMETRIC SECURITY DIVISION | OPERATOR: AMIR ALI</p>
        <p className="website-link">OFFICIAL WEBSITE: <a href="https://darkforce.company" target="_blank" rel="noopener noreferrer">darkforce.company</a></p>
      </div>
      <FaceDetection />
    </>
  )
}

export default App
